var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlayIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2458 8.70823L2.42925 14.7513C1.51129 15.2636 0.333252 14.6433 0.333252 13.6105V1.52428C0.333252 0.493093 1.50959 -0.128894 2.42925 0.385064L13.2458 6.42816C13.4546 6.54294 13.6282 6.70885 13.7489 6.90906C13.8697 7.10928 13.9333 7.33668 13.9333 7.56819C13.9333 7.79971 13.8697 8.02711 13.7489 8.22732C13.6282 8.42754 13.4546 8.59345 13.2458 8.70823V8.70823Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIcon1);
export default __webpack_public_path__ + "static/media/playIcon1.d6fcc841161474bd709ddeafb54d04d9.svg";
export { ForwardRef as ReactComponent };